import React from 'react';
import TaskInput from '../components/TaskInput';
import TaskList from '../components/TaskList';
import backgroundImage from '../images/door_background_images.png';

const TasksPage = () => {
  return (
    <div 
      className="min-h-screen pt-20 pb-3 mt-20 relative overflow-x-hidden bg-no-repeat md:bg-fixed bg-scroll
                 bg-cover sm:bg-contain md:bg-cover 
                 bg-center sm:bg-top md:bg-center"
      style={{
        backgroundImage: `url(${backgroundImage})`
      }}
    >
      {/* Dark overlay for better readability */}
      <div className="absolute inset-0 bg-black/50 z-0"></div>

      <div className="relative w-full max-w-6xl mx-auto px-3 sm:px-6 lg:px-8 z-20">
        {/* Header Section */}
        <div className="mb-6 sm:mb-8">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 text-center">
            Task Mastery
          </h1>
          <p className="text-base sm:text-lg text-gray-300 text-center max-w-2xl mx-auto px-2">
            Orchestrate your productivity with precision and elegance. Transform
            intentions into achievements through mindful task management.
          </p>
        </div>

        {/* Main Content Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 w-full">
          {/* Task Input Section - Takes up 1 column */}
          <div className="lg:col-span-1">
            <TaskInput />
          </div>

          {/* Task List Section - Takes up 2 columns */}
          <div className="lg:col-span-2">
            <TaskList />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TasksPage;

